<template>
  <div class="invoice-create-bottom-grid">
    <article class="invoice-create-card">
      <header class="invoice-create-card__head">
        <h3>
          <i class="fa fa-commenting-o invoice-create-section-icon invoice-create-section-icon--comments" aria-hidden="true"></i>
          {{ text.create.ui.comments.title }}
        </h3>
      </header>

      <div class="invoice-create-comments-box">
        <textarea
          :value="comments"
          class="invoice-create-comments"
          :placeholder="text.create.ui.comments.placeholder"
          @input="$emit('comments-change', $event?.target?.value || '')"
        ></textarea>
      </div>
    </article>

    <article class="invoice-create-card invoice-create-summary-card">
      <div class="invoice-create-summary-total">
        <span>{{ text.create.ui.totals.total }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatCurrency(total, { currency }) }}</strong>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/numberFormat';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteCreateBottomSection',
  props: {
    comments: {
      type: String,
      default: '',
    },
    total: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'MXN',
    },
  },
  emits: ['comments-change'],
  data() {
    return {
      text,
    };
  },
  methods: {
    formatCurrency,
  },
};
</script>
